<template>
  <b-container id="offrePro" class="mb-5">
    <div>
      <b-tabs content-class="mt-3">
        <b-tab :title="item" :active="index == 0 ? true : false" v-for="(item, index) in listName" :key="index">
          <Content :name="item" />
        </b-tab>
      </b-tabs>
    </div>
  </b-container>
</template>
<script>
import Content from "./comps/Content.vue";
export default {
  props: ["name"],
  components: {
    Content,
  },
  data() {
    return {
      listName: ["CGP", "Agrégateurs", "Family Office", "Banques Privées", "Banques en ligne"],
    };
  },
};
</script>
<style lang="scss">
@import "../../../../sass/_variables.scss";
#offrePro {
  .nav-link {
    color: $blue_color;
  }
}
</style>
